// extracted by mini-css-extract-plugin
module.exports = {"Component":"App_Component__1Bwx9","Component_generator":"App_Component_generator__36PdM","Component_resource":"App_Component_resource__1X8nl"};